/**
 *  @class
 *  @function MaxHeight
 */
if (!customElements.get('max-height')) {
  class MaxHeight extends HTMLElement {
    constructor() {
      super();
      this.content = this.querySelector('.max-height--inner-content');
      this.toggle = this.querySelector('.max-height--toggle');
      this.max = this.dataset.max;
    }

    connectedCallback() {
      this.toggle.addEventListener('click', this.onClick.bind(this));
      window.addEventListener('resize', this.checkVisible.bind(this));


      this.checkVisible();
    }

    checkVisible() {
      if (this.content.offsetHeight > this.max) {
        this.showToggle();
      } else {
        this.hideToggle();
      }
    }
    showToggle() {
      this.classList.add('max-height--active');
    }
    hideToggle() {
      this.classList.remove('max-height--active');
    }
    onClick() {
      const wasExpanded = this.classList.contains('max-height--enabled');
      this.classList.toggle('max-height--enabled');
      const nowExpanded = this.classList.contains('max-height--enabled');
      if (!this.hasAttribute('data-scroll-on-expand')) return;      
      const block = this.dataset.scrollOnExpand === 'nearest' ? 'nearest' : 'start';
      const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const shouldScroll = !nowExpanded && wasExpanded;
      if (shouldScroll) {
        const scrollTarget = this.closest(".shopify-section") || this;
        requestAnimationFrame(() => {
          scrollTarget.scrollIntoView({ behavior, block, inline: 'nearest' });
        });
      }
    }
  }
  customElements.define('max-height', MaxHeight);
}
